import {DefaultService} from "@/services/DefaultService";
import API from "@/plugins/axios";
import { SolicitudTorres } from "@/models/SolicitudTorres";

class SolicitudTorresService extends DefaultService {
  constructor(url: string) {
    super(url);
  }

  getSolicitudesTorresAll(filters: any): Promise<any> {
    let query = new URLSearchParams(filters).toString().replace(/null/g,'');
    return API.get(`${this.url}/?${query}`);
  }

  getSolicitudesTorresById(id: number | string): Promise<any> {
    return API.get(`${this.url}/${id}`);
  }

  createSolicitudesTorres(data: any): Promise<any> {
    return API.post(`${this.url}`, data);
  }

  updateSolicitudesTorres(id: number | string, data: any): Promise<any> {
    return API.request({
      url: `${this.url}/${id}`,
      data: data,
      method: `PUT`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
  }

  deleteSolicitudesTorres(id: number | string): Promise<any> {
    return API.delete(`${this.url}/${id}`);
  }

  getDomicilios() {
    return API.get(`${this.url}/getDomicilios`);
  }

  changeStatus(id: number | string, data: any): Promise<any> {
    return API.post(`${this.url}/${id}/changeStatus`, data);
  }

  firmarDocumento(id: number | string, data: any): Promise<any> {
    return API.post(`${this.url}/${id}/firmarDocumento`, data);
  }

  viewSolicitudFirmada(idSolicitudTorre: number) {
    return API.request({
        url: `${this.url}/${idSolicitudTorre}/viewDictamenPDF`,
        data: {
          'firmado': true
        },
        method: 'POST',
        responseType: 'blob'
      });
  }

  viewEstadoCuenta(url: any, data: any, type: any, name: string): Promise<any>{
    return API.request({
      url: url,
      data: data,
      method: type,
      responseType: 'blob'
    });
  }

}

export { SolicitudTorresService };